import {init} from '../common/init.js';
import {pushState} from '../common/pushState.js';
import {commonSearch} from '../common/commonSearch.js';

(function ($) {

	function showClip(tape, clipId) {
		$('#videoWindow').videoWindow('open', true);
		if (clipId ) {
			return $("#videoWindow").videoWindow('showClip', {
				clipId: clipId,
				isWritable: false,
				clipType: ''
			});
		}else {
			return commonSearch.showTape(tape);
		}
	}

	window.initPage = function () {
		let dfd = new $.Deferred(),
			page = $(".reelPage"),
			tape = page.data('tape'),
			clipId = page.data('clip');
		window.reelId = tape.id;
		pushState.hideReel = true;
		
		$.when(showClip(tape, clipId)).done(function () {
			$("#videoWindow .close").remove();
			dfd.resolve();
		}).fail(function () {
			dfd.reject();
		});
		return dfd.promise();
	};

	init.init();
	$(document).ready(function() {
		init.initPage();
	});


}(jQuery));
